// toast-notifier.tsx
import React from "react";
import { toast } from "react-toastify";

import { AlertTriangle, CheckCircle } from "lucide-react";

type ToastType = "success" | "error" | "info";

const Toast = (
  type: ToastType,
  messages: string[] | string,
  heading: string,
  email?: string
) => {
  if (type === "success") {
    toast(
      () => (
        <div style={{ width: 380 }}>
          <div
            style={{ fontSize: "14px", background: "#F0FDF4" }}
            className="d-flex align-items-center gap-2 px-2 py-1"
          >
            <CheckCircle className="text-success" size={16} />
            <span className="text-success fw-bold">{heading || "Success"}</span>
          </div>
          <div
            style={{
              fontSize: "14px",
              lineHeight: "150%",
              color: "#A1A1A1",
              background: "white",
            }}
            className="px-2 py-2"
          >
            {Array.isArray(messages) ? (
              messages.map((item, idx) => <span key={idx}>{item}</span>)
            ) : (
              <span>{messages}</span>
            )}
            <strong style={{ color: "#232323" }}>{email}</strong>
          </div>
        </div>
      ),
      { autoClose: 3000, hideProgressBar: true }
    );
  }
  if (type === "error") {
    toast(
      <div style={{ width: 380 }}>
        <div
          style={{ fontSize: "14px", background: "#FEE2E2" }}
          className="d-flex align-items-center gap-2 px-2 py-1"
        >
          <AlertTriangle className="text-danger" size={16} />
          <span className="text-danger fw-bold">{heading || "Error"}</span>
        </div>
        <div
          style={{
            fontSize: "14px",
            lineHeight: "150%",
            color: "#DC2626",
            background: "white",
          }}
          className="px-2 py-2"
        >
          {Array.isArray(messages) ? (
            messages.map((msg, i) => <div key={i}>{msg}</div>)
          ) : (
            <div>{messages}</div>
          )}
        </div>
      </div>,
      { autoClose: 4000, hideProgressBar: true }
    );
  }
  if (type === "info") {
    toast(
      <div style={{ width: 380 }}>
        <div
          style={{ fontSize: "14px", background: "#FEF6DB", color: "#F59E0B" }}
          className="d-flex align-items-center gap-2 px-2 py-1"
        >
          <AlertTriangle color="#F59E0B" size={16} />
          <span className="fw-bold">{heading || "Error"}</span>
        </div>
        <div
          style={{
            fontSize: "14px",
            lineHeight: "150%",
            color: "#F59E0B",
            background: "white",
          }}
          className="px-2 py-2"
        >
          {Array.isArray(messages) ? (
            messages.map((msg, i) => <div key={i}>{msg}</div>)
          ) : (
            <div>{messages}</div>
          )}
        </div>
      </div>,
      {
        autoClose: 4000,
        hideProgressBar: true,
      }
    );
  }
};

export default Toast;
